import './AppPageHeader.scss';
import React from 'react';
import classNames from 'classnames';
import InfoTooltip from '../InfoTooltip';

export type AppPageHeaderProps = {
  title?: string | React.ReactNode;
  titleInfo?: string | React.ReactNode;
  left?: React.ReactNode;
  center?: React.ReactNode;
  right?: React.ReactNode;
} & React.HTMLAttributes<HTMLDivElement>;

export default function AppPageHeader(props: AppPageHeaderProps) {
  return (
    <>
      <div className={classNames('app-page-header', { [props.className]: !!props.className })}>
        <div className="app-page-header-left-content">
          <h2 className="app-page-header-content-title">{props.title}</h2>
          {props.titleInfo && <InfoTooltip size="mini" message={props.titleInfo} />}
          {props.left}
        </div>
        <div className="app-page-header-center-content">{props.center}</div>
        <div className="app-page-header-right-content">{props.right}</div>
      </div>
    </>
  );
}
